<template>
  <yams-template>
    <template #header>
      <div class="mr-5">
        <h4 class="text-primary font-weight-bold">Interventions ({{ lines }})</h4>
      </div>
      <div class="mr-4">
        <NavParcAuto></NavParcAuto>
      </div>
      <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
        <button type="button" class="btn " @click.prevent="changeAffichage('table')"
          :class="{ 'active': affichage === 'table' }">
          <i class="fa-solid fa-bars"></i>
        </button>
        <button type="button" class="btn " @click.prevent="changeAffichage('card')"
          :class="{ 'active': affichage === 'card' }">
          <i class="fa-solid fa-border-all"></i>
        </button>
      </div>
      <button type="button" class="btn-yams btn-active mr-2" @click="openCreateModal()">
        Ajouter une intervention <i class="fa-solid fa-plus"></i>
      </button>
    </template>
    <template #content>
      <!-- Ajout du composant FilterCustom -->
      <div class="card card-body mb-2 p-2">
        <FilterCustom :selectOptions="filterSelectOptions" :baseUrl="baseUrl" :defaultValues="defaultFilterValues"
          :existingSelectors="['vehicule', 'garage', 'type']" :hasDateFilter="true" @filter-applied="onFilterApplied"
          @filter-reset="onFilterReset" @get-existing-selectors="getExistingSelectorsParams"
          @reset-existing-selectors="resetExistingSelectors">
          <!-- Intégration des sélecteurs existants via slot -->
          <template #existing-selectors>
            <div class="filter-select-wrapper">
              <label>Véhicule</label>
              <SelectVehicule :creation="false" :key="'vehicule-' + componentKeys.vehicule" :line="selectedValues.vehicule"
                @set-selected="(value, object) => onSelectChange('vehicule', value, object)" />
            </div>

            <div class="filter-select-wrapper">
              <label>Garage</label>
              <SelectGarage :creation="false" :key="'garage-' + componentKeys.garage" :line="selectedValues.garage"
                @set-selected="(value, object) => onSelectChange('garage', value, object)" />
            </div>
          </template>
        </FilterCustom>
      </div>

      <div class="card mb-5">
        <div class="card-body p-1">
          <DataTableBackend :key="key" :url="currentUrl" :view-mode="affichage" :columns="columns" :table="table"
            selection @row-click="openShowModal" @set-selected-rows="getSelection" v-on:set-total-records="updateLines">
            <template #statut="slotProps">
              <span class="p-2 rounded-pill badge" :class="{
                'badge-success': slotProps.data.statut === 'Confirmé',
                'badge-secondary': slotProps.data.statut === 'Brouillon'
              }">
                {{ slotProps.data.statut }}
              </span>
            </template>
          </DataTableBackend>
        </div>
      </div>
    </template>
  </yams-template>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
import NavParcAuto from '../NavParcAuto.vue';
import FilterCustom from '@/components/FilterCustom.vue';

const FormIntervention = defineAsyncComponent(() => import('@/views/parc-auto/interventions/FormIntervention.vue'));
const ShowIntervention = defineAsyncComponent(() => import('@/views/parc-auto/interventions/ShowIntervention.vue'));
const SelectVehicule = defineAsyncComponent(() => import('@/views/parc-auto/vehicules/SelectVehicule.vue'));
const SelectGarage = defineAsyncComponent(() => import('@/views/configurations/interventions/garages/SelectGarage.vue'));

export default defineComponent({
  name: 'IndexIntervention',
  components: { NavParcAuto, FilterCustom, SelectVehicule, SelectGarage },
  data() {
    return {
      key: 1,
      lines: 0,
      affichage: "table",
      table: "interventions",
      selection: [],
      baseUrl: this.$store.getters.apiUrl + '/api/interventions',
      currentUrl: this.$store.getters.apiUrl + '/api/interventions',

      // Pour les composants Select
      componentKeys: {
        vehicule: 1,
        garage: 1,
        type: 1,

      },

      // Valeurs sélectionnées des filtres
      selectedValues: {
        vehicule: '',
        garage: '',
        type: '',

      },

      // Objets complets sélectionnés (pour les sélecteurs qui renvoient des objets)
      selectedObjects: {
        vehicule: null,
        garage: null
      },

      // Valeurs par défaut pour les filtres
      defaultFilterValues: {
        // Laisser vide pour afficher toutes les interventions par défaut
      },

      // Options pour les filtres personnalisés
      filterSelectOptions: [
        {
          name: 'type',
          label: 'Type d\'intervention',
          placeholder: 'Tous les types',
          options: [
            { value: 'Entretien', label: 'Entretien' },
            { value: 'Réparation', label: 'Réparation' }
          ]
        }
      ],

      columns: [
        {
          key: 'vehicule',
          label: 'Immatriculation',
          exportable: true,
          sortable: true
        },
        {
          key: 'date_debut',
          label: 'Debut',
          format: 'date',
          exportable: true
        },
        {
          key: 'date_fin',
          label: 'Fin',
          format: 'date',
          exportable: true
        },
        {
          key: 'type',
          label: 'Type',
          exportable: true,
          sortable: true
        },
        {
          key: 'montant',
          label: 'Montant',
          format: 'money',
          exportable: true,
          sortable: true
        },
        {
          key: 'garage',
          label: 'Garage',
          exportable: true,
          sortable: true
        },
        {
          key: 'statut',
          label: 'Statut',
          selectable: true,
          sortable: true
          // format: 'state'
        }
      ]
    };
  },
  methods: {
    // Méthodes pour FilterCustom
    onSelectChange(field, value, object = null) {
      this.selectedValues[field] = value;

      // Si un objet complet est fourni, le stocker
      if (object && (field === 'vehicule' || field === 'garage')) {
        this.selectedObjects[field] = object;
      }
    },

    onFilterApplied(filteredUrl, values) {
      this.currentUrl = filteredUrl;
      this.key++; // Forcer la réactualisation du DataTableBackend
    },

    onFilterReset(baseUrl) {
      this.currentUrl = baseUrl;
      this.key++;
    },

    getExistingSelectorsParams(callback) {
      const existingParams = {};

      // Ajouter uniquement les sélecteurs qui ont des valeurs
      Object.keys(this.selectedValues).forEach(key => {
        if (this.selectedValues[key]) {
          existingParams[key] = this.selectedValues[key];
        }
      });

      callback(existingParams);
    },

    resetExistingSelectors() {
      // Réinitialiser toutes les valeurs
      Object.keys(this.selectedValues).forEach(key => {
        this.selectedValues[key] = '';
      });

      Object.keys(this.selectedObjects || {}).forEach(key => {
        this.selectedObjects[key] = null;
      });

      // Forcer le rafraîchissement des composants Select
      Object.keys(this.componentKeys).forEach(key => {
        this.componentKeys[key]++;
      });
    },

    // Méthodes existantes
    changeAffichage(type) {
      this.affichage = type;
      this.key++
    },

    getSelection(selection) {
      this.selection = selection
    },

    openCreateModal() {
      this.$dialog.open(FormIntervention, {
        props: {
          header: "Nouvelle intervention",
          style: {
            width: '50vw'
          },
          modal: true
        },
      });
    },

    openShowModal(objData) {
      this.$dialog.open(ShowIntervention, {
        props: {
          header: "Intervention #" + objData.id,
          style: {
            width: '50vw'
          },
          modal: true
        },
        data: objData
      });
    },

    updateLines(nb_lines) {
      this.lines = nb_lines
    }
  }
});
</script>

<style scoped>
.filter-select-wrapper {
  min-width: 200px;
  margin-bottom: 10px;
}

/* Retirer le flex du card-body */
:deep(.card-body) {
  flex: none !important;
  min-height: 1px;
  padding: 1.25rem;
}
</style>